import React, { useState, useEffect } from 'react';
import { Typography, Paper, Grid, Button, CircularProgress } from '@material-ui/core';

import { useDispatch, useSelector } from 'react-redux';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import {
  getSolicitudId,
  refrescarUltimasAutorizaciones,
} from '../../redux/actions/autorizacionActions';

import { getPermisoCC } from '../../redux/actions/authActions';

import useStyles from './styles';

import ModalSolicitud from '../../components/ModalSolicitud';
import ListaHorarios from '../../components/BotonListaHorarios';
import BotonRefresh from '../../components/BotonRefresh';

import Reserva from '../../components/Reserva';
import ReservaCancelada from '../../components/Reserva/cancelada';
import moment from 'moment';
import api from '../../helpers/api';
import Swal from 'sweetalert2';

export default () => {
  const classes = useStyles();
  const quiebre = useMediaQuery('(max-width:475px)');

  const dispatch = useDispatch();

  const [openSolicitud, setOpenSolicitud] = useState(false);
  const [reserva, setReserva] = useState(null);

  const { listado, loading, error } = useSelector((state) => state.autorizaciones);
  const { token, usuario, esencialCC, permisoCC } = useSelector((state) => state.auth);

  const onCancelar = (reserva) => {
    setReserva(reserva);
  };

  useEffect(() => {
    const confirmAction = async () => {
      try {
        const response = await api.delete(`v1/autorizaciones/${reserva.id}`, {
          headers: {
            Authorization: token,
          },
        });

        dispatch(refrescarUltimasAutorizaciones(token));

        if (response.data.code === 200) {
          Swal.fire({
            title: 'Viaje cancelado',
            text: `Tu viaje ha sido cancelado`,
            icon: 'success',
            allowOutsideClick: true,
            confirmButtonText: 'Aceptar',
          });
        } else {
          Swal.fire({
            title: 'Error',
            text: `No pudimos cancelar tu viaje en este momento`,
            icon: 'danger',
            allowOutsideClick: true,
            confirmButtonText: 'Aceptar',
          });
        }
      } catch (ex) {
        Swal.fire({
          title: 'Error',
          text: `No pudimos cancelar tu viaje en este momento`,
          icon: 'danger',
          allowOutsideClick: true,
          confirmButtonText: 'Aceptar',
        });
      }
    };

    if (reserva !== null) {
      Swal.fire({
        title: '¿Querés cancelar tu viaje?',
        text: `Se cancelará tu viaje ${reserva.servicio.numero} del ${moment(
          reserva.servicio.fecha
        ).format('DD/MM/YYYY')}`,
        icon: 'warning',
        showCancelButton: true,
        allowOutsideClick: false,
        confirmButtonColor: '#d33',
        confirmButtonText: 'Si, cancelar',
        cancelButtonText: 'No',
      }).then((result) => {
        if (result.value) {
          confirmAction(reserva);
        }
        setReserva(null);
      });
    }
  }, [reserva, token, dispatch]);

  const handleClickOpenSolicitud = () => {
    dispatch(getSolicitudId(token));
    setOpenSolicitud(true);
  };

  useEffect(() => {
    dispatch(refrescarUltimasAutorizaciones(token));
    dispatch(getPermisoCC(token));
  }, [dispatch, token]);

  useEffect(() => {
    if (error) {
      if (error.message)
        Swal.fire({
          title: 'Atencion',
          text: `${error.message}`,
          icon: 'warning',
          allowOutsideClick: true,
          confirmButtonText: 'Aceptar',
        });
    }
  }, [error]);

  return (
    <>
      <ModalSolicitud open={openSolicitud} setOpen={setOpenSolicitud}></ModalSolicitud>
      <BotonRefresh token={token} />
      <Grid container spacing={1} className={classes.container}>
        <Grid item xs={12}>
          <Typography
            className={classes.typoSaludo}
            style={{ fontSize: quiebre ? 'x-large' : 'xx-large' }}
          >
            Hola, {usuario.nombre}
          </Typography>
           {esencialCC && permisoCC && (
            <Button
              variant='contained'
              color='secondary'
              className={classes.button}
              aria-label='outlined primary button group'
              onClick={() => handleClickOpenSolicitud()}
              fullWidth={quiebre}
              style={quiebre ? {} : { padding: '0.5% 5%' }}
            >
              Nueva Reserva
            </Button>
          )}
        </Grid>
        <Grid item xs={12}>
          <Typography className={classes.typo}>Próximos viajes</Typography>
          <Typography className={classes.typo}><b>La reserva de tren no asegura disponibilidad de asiento.</b></Typography>
          {/* <ListaHorarios linea={0} botonIcons={false} quiebre={quiebre} /> */}
          {listado.length > 0 ? (
            <Grid container spacing={3}>
              {listado.map((r) => (
                <Grid item md={3} xs={12} className={classes.textCenter} key={r.id}>
                  {r.servicio.cancelado === 1 ? (
                    <ReservaCancelada
                      reserva={r}
                      modoEdicion={false}
                      onCancelarReserva={onCancelar}
                      btnDuplicar={true}
                    />
                  ) : (
                    <Reserva
                      reserva={r}
                      modoEdicion={false}
                      onCancelarReserva={onCancelar}
                      btnDuplicar={true}
                    />
                  )}
                </Grid>
              ))}
            </Grid>
          ) : (
            <Paper elevation={0} className={classes.vacio}>
              {loading ? (
                <CircularProgress disableShrink />
              ) : (
                <Typography>
                  <b>No tenes reservas generadas.</b>
                </Typography>
              )}
            </Paper>
          )}
        </Grid>
      </Grid>
    </>
  );
};
